export function hkfsFormatter(hkfs) {
  switch (hkfs) {
    case 0:
      return "正常还款";
    case 1:
      return "提前还款";
    default:
      return hkfs;
  }
}
export function zlywztFormatter(zlywzt) {
  switch (Number.parseInt(zlywzt)) {
    case 0:
      return "正常";
    case 1:
      return "逾期";
    case 2:
      return "结清";
    case 3:
      return "异常";
    default:
      return zlywzt;
  }
}
export function hkztFormatter(hkzt) {
  switch (Number.parseInt(hkzt)) {
    case 0:
      return "待还";
    case 1:
      return "已还";
    case 2:
      return "逾期";
    case 3:
      return "部分还款";
    case 4:
      return "提前还款";
    case 5:
      return "逾期已还";
    case 6:
      return "逾期部分还款";
    case 7:
      return "异常";
    default:
      return hkzt;
  }
}
export function hkztColorFormatter(hkzt) {
  switch (Number.parseInt(hkzt)) {
    case 0:
      // return "orange";
      return "#888888";
    case 1:
      // return "LightSkyBlue";
      return "#99CC33";
    case 2:
      return "red";
    //return "#CD5C5C"
    case 3:
      return "LightSkyBlue";
    case 4:
      return "#99CC33";
    case 5:
      return "#99CC33";
    case 6:
      return "red";
    case 7:
      return "DarkOrange";
    default:
      return "black";
  }
}

// str：字符串，frontLen：前面保留位数，endLen：后面保留位数
export function plusXing(str, frontLen, endLen) {
  let len = str.length - frontLen - endLen;
  let xing = "";
  for (let i = 0; i < len; i++) {
    xing += "*";
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
}
